import classnames from 'classnames';
import React, { useState } from 'react';
import { MultiSelectOption } from '../../../global/multi-select-list/_multi-select-option';
import ChevronSVG from '../../../../images/svg/icons8-expand-arrow';
import Text from '../../../global/text/text';
import { IPermissionsDTO } from '../../../../api/roles.dao';

interface IProps{
    permissions: IPermissionsDTO[];
    id: string;
    title: string;
    onPermissionChange: (groupId: string, id: number) => void;
}

export const RolePermissionFormItem = (props: IProps) => {
    const { title, id, permissions, onPermissionChange } = props;
    const [isOpen, setIsOpen] = useState(true);

    return (
        <div>
            <div className={classnames(
                'role-form__header', {
                    'role-form__header--active': isOpen,
                })}
                 onClick={() => setIsOpen(state => !state)}
            >
                <div className='role-form__header-name'>
                    <div className='role-form__header-title'>
                        <Text message={title} id={id} description='Popover title text' withEllipsis/>
                    </div>
                    {permissions.length ? (
                        <div className='role-form__header-name__icon'>
                            <ChevronSVG/>
                        </div>
                    ) : null}
                </div>
            </div>
            {isOpen && permissions.slice()
                .map(({title: permission, description, status: permissionStatus, id: permissionId, intlId}) => (
                    <div key={permission} className='role__row'>
                        <div className='role__row__text-content overflow-ellipsis'>
                            <Text className='role__row__text-content__title' message={permission} id={`${intlId}Title`} description='Permission name'/>
                            <Text message={description} id={`${intlId}Description`} description='Permission description' withEllipsis/>
                        </div>
                        <MultiSelectOption
                            isSelected={permissionStatus}
                            isInsideGroup={false}
                            onClick={() => onPermissionChange(id, permissionId)}
                        />
                    </div>
                ))}
        </div>
    );
};